import axios from "axios";
import { getActiveServer, switchToBackup } from "./serverManager";

const api = axios.create();

// Always use the current active server
api.interceptors.request.use((config) => {
  config.baseURL = getActiveServer();
  return config;
});
console.log(getActiveServer())
// Failover: retry request with backup if primary fails
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      // Likely a network/connection issue
      switchToBackup();
      error.config.baseURL = getActiveServer();
      return axios.request(error.config); // retry with backup
    }
    return Promise.reject(error);
  }
);

export default api;